import { API } from "../api"
import {
  firebuyer,
  buyerGoogleProvider,
  buyerFbProvider
} from "./firebase-buyer/firebase-buyer"

function getGoogleApiToken(body, uuid) {
  return new Promise(async function(resolve, reject) {
    const signUpUrl = `/customers/${uuid}/sign_up`
    try {
      const res = await API.post(signUpUrl, JSON.stringify(body))
      resolve(res.data)
    } catch (error) {
      if (error.response) {
        reject(error.response.data)
      } else if (error.request) {
        reject(error.request)
      } else {
        reject(error.message)
      }
    }
  })
}

//Google Log in
function buyerGoogleSignIn(uuid, order_uuid) {
  return new Promise(async function(resolve, reject) {
    try {
      const res = await firebuyer.auth().signInWithPopup(buyerGoogleProvider)
      const firstName = res.additionalUserInfo.profile.given_name
      const lastName = res.additionalUserInfo.profile.family_name
      const email = res.additionalUserInfo.profile.email
      const token = await res.user.getIdToken()
      const apiToken = await getGoogleApiToken(
        {
          auth_token: token,
          order_uuid: order_uuid,
          gateway: "google",
          firstname: firstName,
          lastname: lastName,
          email: email
        },
        uuid
      )
      resolve(apiToken)
    } catch (error) {
      reject(error)
    }
  })
}

//Google Log in
function getBuyerGoogleDetails(uuid, order_uuid) {
  return new Promise(async function(resolve, reject) {
    try {
      const res = await firebuyer.auth().signInWithPopup(buyerGoogleProvider)
      const firstName = res.additionalUserInfo.profile.given_name
      const lastName = res.additionalUserInfo.profile.family_name
      const email = res.additionalUserInfo.profile.email
      const userDetails = {
        firstName: firstName,
        lastName: lastName,
        email: email
      }
      // const token = await res.user.getIdToken()
      // const apiToken = await getGoogleApiToken(
      //   {
      //     auth_token: token,
      //     order_uuid: order_uuid,
      //     gateway: "google",
      //     firstname: firstName,
      //     lastname: lastName,
      //     email: email
      //   },
      //   uuid
      // )
      resolve(userDetails)
    } catch (error) {
      reject(error)
    }
  })
}

function getFacebookApiToken(body, uuid) {
  return new Promise(async function(resolve, reject) {
    const signUpUrl = `/customers/${uuid}/sign_up`
    try {
      const res = await API.post(signUpUrl, JSON.stringify(body))
      resolve(res.data)
    } catch (error) {
      if (error.response) {
        reject(error.response.data)
      } else if (error.request) {
        reject(error.request)
      } else {
        reject(error.message)
      }
    }
  })
}

//Facebook Log In
function buyerFacebookSignIn(uuid, order_uuid) {
  return new Promise(async function(resolve, reject) {
    try {
      const res = await firebuyer.auth().signInWithPopup(buyerFbProvider)
      const firstName = res.additionalUserInfo.profile.first_name
      const lastName = res.additionalUserInfo.profile.last_name
      const email = res.additionalUserInfo.profile.email
      const token = await res.user.getIdToken()
      const apiToken = await getFacebookApiToken(
        {
          auth_token: token,
          order_uuid: order_uuid,
          gateway: "fb",
          firstname: firstName,
          lastname: lastName,
          email: email
        },
        uuid
      )
      resolve(apiToken)
    } catch (error) {
      reject(error)
    }
  })
}

function getBuyerFacebookDetails(uuid, order_uuid) {
  return new Promise(async function(resolve, reject) {
    try {
      const res = await firebuyer.auth().signInWithPopup(buyerFbProvider)
      const firstName = res.additionalUserInfo.profile.first_name
      const lastName = res.additionalUserInfo.profile.last_name
      const email = res.additionalUserInfo.profile.email
      const userDetails = {
        firstName: firstName,
        lastName: lastName,
        email: email
      }
      // const token = await res.user.getIdToken()
      // const apiToken = await getFacebookApiToken(
      //   {
      //     auth_token: token,
      //     order_uuid: order_uuid,
      //     gateway: "fb",
      //     firstname: firstName,
      //     lastname: lastName,
      //     email: email
      //   },
      //   uuid
      // )
      resolve(userDetails)
    } catch (error) {
      reject(error)
    }
  })
}

export {
  buyerGoogleSignIn,
  buyerFacebookSignIn,
  getBuyerGoogleDetails,
  getBuyerFacebookDetails
}
